export default __webpack_public_path__ + "static/media/landc.cadebb3e.png";